import Attachment from './Attachment'

export default Attachment
